var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1ManyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86079 33.8812C14.3515 37.6008 31.0449 35.6267 34.81 25.59C38.5752 15.5534 34.6756 10.0883 26.1848 6.38945C17.6941 2.69064 8.85752 -0.738033 5.1116 9.29863C1.36568 19.3353 -2.62997 30.1824 5.86079 33.8812Z",
    fill: "#99A1BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7856 12.6044C29.5046 6.71299 12.8915 4.10072 6.77113 12.7761C0.650726 21.4515 3.06512 27.7861 10.3513 33.6574C17.6375 39.5287 25.3245 45.2327 31.4263 36.5521C37.5282 27.8715 44.0718 18.4757 36.7856 12.6044Z",
    fill: "#35B0F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53638 28.0839V19.5854L19.602 24.6845V34.3161L8.53638 28.0839Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03369 19.0598V14.8511L19.6023 20.4746L19.6023 24.8469L8.03369 19.0598Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1709 19.0598V14.8511L19.6023 20.4746L19.6023 24.8469L31.1709 19.0598Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.668 28.0839V19.5854L19.6023 24.6845V34.3161L30.668 28.0839Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0993 9.58984L8.03369 14.8508L19.5145 20.3467L31.1709 14.8508L19.0993 9.58984Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0059 7.07296V1",
    stroke: "#017CBF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0059 1L15.5222 4.64378",
    stroke: "#017CBF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0058 1L22.4895 4.64378",
    stroke: "#017CBF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0952 29.4362L38.1235 32.4727",
    stroke: "#5C6996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1236 32.473L36.8485 27.4955",
    stroke: "#5C6996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1234 32.4733L33.3646 33.807",
    stroke: "#5C6996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77023 29.4357L1.74194 32.4722",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74185 32.4725L3.01697 27.495",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74204 32.4728L6.50086 33.8065",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1ManyIcon);
export default __webpack_public_path__ + "static/media/1_ many-icon.884a3e6ce73d4e4a7d932154936840e8.svg";
export { ForwardRef as ReactComponent };